import { HttpService } from "../../modules/shared/services/http.service";
import { 
	PaymentMilestone, 
	PaymentMilestoneCreateDto, 
	PaymentMilestoneStage, 
	PaymentMilestoneStageCreateDto,
	PaymentMilestoneResponse,
	PaymentMilestoneStageResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Payment Milestones CRUD Functions
export const createPaymentMilestone = async (data: PaymentMilestoneCreateDto): Promise<PaymentMilestone> => {
	const response = await HttpService.post("api/v1/payment-milestones", data, headers, true);
	return response;
};

export const updatePaymentMilestone = async (id: number, data: Partial<PaymentMilestoneCreateDto>): Promise<PaymentMilestone> => {
	const response = await HttpService.patch(`api/v1/payment-milestones/${id}`, data, headers, true);
	return response;
};

export const getPaymentMilestoneById = async (id: number): Promise<PaymentMilestone> => {
	const response = await HttpService.get(`api/v1/payment-milestones/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getPaymentMilestones = async (query?: Record<string, string | number | boolean>): Promise<PaymentMilestoneResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/payment-milestones${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};


export const deletePaymentMilestone = async (id: number): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/payment-milestones/${id}`, { "x-custom-lang": "en" }, true);
};

// Payment Milestone Stages CRUD Functions
export const createPaymentMilestoneStage = async (data: PaymentMilestoneStageCreateDto): Promise<PaymentMilestoneStage> => {
	const response = await HttpService.post("api/v1/payment-milestone-stages", data, headers, true);
	return response;
};

export const updatePaymentMilestoneStage = async (id: number, data: Partial<PaymentMilestoneStageCreateDto>): Promise<PaymentMilestoneStage> => {
	const response = await HttpService.patch(`api/v1/payment-milestone-stages/${id}`, data, headers, true);
	return response;
};

export const getPaymentMilestoneStageById = async (id: number): Promise<PaymentMilestoneStage> => {
	const response = await HttpService.get(`api/v1/payment-milestone-stages/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getPaymentMilestoneStages = async (query?: Record<string, string | number | boolean>): Promise<PaymentMilestoneStageResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/payment-milestone-stages${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getPaymentMilestoneStagesByMilestone = async (milestoneId: number): Promise<PaymentMilestoneStage[]> => {
	const response = await HttpService.get(`api/v1/payment-milestone-stages/milestone/${milestoneId}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deletePaymentMilestoneStage = async (id: number): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/payment-milestone-stages/${id}`, { "x-custom-lang": "en" }, true);
};
